import React from 'react'
import FinancialPlanning from "../../resources/financial-planning.jpg"
import General from "../../resources/general-insurance.jpg"
import Tax from "../../resources/tax-planning.jpg"
import Child from "../../resources/child-marriage.jpg"
import Education from "../../resources/education-planning.jpg"
import Retirement from "../../resources/retirement.jpg"
import Research from "../../resources/research.jpg"
import Estate from "../../resources/estate-planning.jpg"
import MutualFunds from "../../resources/account.jpg"
import LifeInsurance from "../../resources/life-insurance.jpg"
import { Link } from 'react-router-dom'
import "./ServicesHome.css";

const ServicesHome = () => {
    return (
        <section className="services">
            <div className="service-page-articles">
                {[
                    {
                        id: 1,
                        heading: "Future Freedom Planning",
                        description: "Plan your finances effectively to achieve your short and long-term goals with expert guidance.",
                        thumbnailImage: FinancialPlanning,
                        route: "/services/future-freedom-planning",
                    },
                    {
                        id: 2,
                        heading: "Mutual Funds",
                        description: "Diversify your portfolio and grow wealth with our curated mutual fund options.",
                        thumbnailImage: MutualFunds,
                        route: "/services/mutual-funds",
                    },
                    {
                        id: 3,
                        heading: "Life Insurance",
                        description: "Secure your family's future with the best life insurance plans tailored to your needs.",
                        thumbnailImage: LifeInsurance,
                        route: "/services/life-insurance",
                    },
                    {
                        id: 4,
                        heading: "General Insurance",
                        description: "Get comprehensive coverage for your health, vehicle, and property with our general insurance plans.",
                        thumbnailImage: General,
                        route: "/services/general-insurance",
                    },
                    {
                        id: 5,
                        heading: "Estate Guidance",
                        description: "Ensure smooth transfer of wealth and assets to your loved ones with expert estate guidance.",
                        thumbnailImage: Estate,
                        route: "/services/estate-guidance",
                    },
                    {
                        id: 6,
                        heading: "Tax Guidance",
                        description: "Minimize your tax liabilities and maximize savings with our tax guidance strategies.",
                        thumbnailImage: Tax,
                        route: "/services/tax-guidance",
                    },
                    {
                        id: 7,
                        heading: "Education Guidance",
                        description: "Secure your child's education with well-structured financial strategies.",
                        thumbnailImage: Education,
                        route: "/services/education-guidance",
                    },
                    {
                        id: 8,
                        heading: "Retirement & Superannuation",
                        description: "Plan ahead for a comfortable and stress-free retirement.",
                        thumbnailImage: Retirement,
                        route: "/services/retirement-superannuation",
                    },
                    {
                        id: 9,
                        heading: "Research & Development",
                        description: "Enhance your business capabilities with innovative research and development strategies.",
                        thumbnailImage: Research,
                        route: "/services/research-development",
                    },
                    {
                        id: 10,
                        heading: "Child Marriage Guidance",
                        description: "Prepare financially for your child's special day with personalized marriage guidance services.",
                        thumbnailImage: Child,
                        route: "/services/child-marriage-guidance",
                    },

                ].map((service) => (
                    <article key={service.id}>
                        <div className="article-wrapper">
                            <figure>
                                <img src={service.thumbnailImage} alt={service.heading} />
                            </figure>
                            <div className="article-body">
                                <h2>{service.heading}</h2>
                                <p>{service.description}</p>
                                <Link to={service.route} className="read-more">
                                    Learn More <span className="sr-only">about {service.heading}</span>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="icon"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                </Link>
                            </div>
                        </div>
                    </article>
                ))}
            </div>
        </section>
    )
}

export default ServicesHome